import React from 'react'
import { FaHeadset, FaMessage } from 'react-icons/fa6'
import { FaPhone } from "react-icons/fa";

const LiveChatIcon = () => {
  const handleClick = () => {
    window.open('https://wa.me/+447586578997', '_blank');
  };

  const phoneNumber = '+447586578997'; // Replace with your phone number
  const handleCallButtonClick = () => {
      window.location.href = `tel:${phoneNumber}`;
    };
  return (
    <div class="live-chat-icon-support">
      <div className="live-chat-icon">
          <FaHeadset />
      </div>
      <div  class="live-chat-popup-content">
          <div className="live-chat-icon" onClick={handleClick}>
            <FaMessage />
          </div>
          <div className="live-chat-icon" onClick={handleCallButtonClick}>
            <FaPhone /> 
          </div>
    </div></div>
    
  )
}

export default LiveChatIcon
